(function () {
  'use strict';
  if (typeof CSSStyleSheet !== 'function' || !('adoptedStyleSheets' in Document.prototype)) return;

  var B = 'button[data-testid="login-button"]';
  var CSS = [
    B + ' {',
    '  background-color: #ffffff !important;',
    '  box-shadow: inset 0 0 0 1px #d9d2c7 !important;',
    '  transition: background-color var(--sp-dur-2, 220ms) var(--sp-ease-out, cubic-bezier(0.22, 1, 0.36, 1)),',
    '    box-shadow var(--sp-dur-2, 220ms) var(--sp-ease-out, cubic-bezier(0.22, 1, 0.36, 1)) !important;',
    '}',
    B + ' span { color: var(--sp-color-graphite, #101010) !important; }',
    B + ' svg { color: #5433eb !important; }',
    '@media (hover: hover) {',
    '  ' + B + ':hover { background-color: var(--sp-color-cream, #f8f5f2) !important; box-shadow: inset 0 0 0 1px var(--sp-color-graphite, #101010) !important; }',
    '}',
    B + ':focus-visible { outline: 2px solid var(--sp-color-graphite, #101010) !important; outline-offset: 2px !important; }',
    '@media (prefers-reduced-motion: reduce) { ' + B + ' { transition: none !important; } }'
  ].join('\n');

  var sheet = new CSSStyleSheet();
  sheet.replaceSync(CSS);
  var watched = new WeakSet();

  function ensure(root) {
    var list = root.adoptedStyleSheets;
    if (list.indexOf(sheet) === -1) root.adoptedStyleSheets = list.concat(sheet);
  }

  function watch(root, onChange) {
    if (watched.has(root) || typeof MutationObserver !== 'function') return;
    watched.add(root);
    new MutationObserver(onChange).observe(root, { childList: true, subtree: true });
  }

  function applyLogin(el) {
    if (!el.shadowRoot) return false;
    ensure(el.shadowRoot);
    watch(el.shadowRoot, function () { ensure(el.shadowRoot); });
    return true;
  }
  function scanAccount(root) {
    root.querySelectorAll('shop-login').forEach(function (el) {
      if (applyLogin(el)) return;
      [100, 400, 1200, 3000].forEach(function (d) { setTimeout(function () { applyLogin(el); }, d); });
    });
  }

  function sweep() {
    document.querySelectorAll('shopify-account').forEach(function (host) {
      var r = host.shadowRoot;
      if (!r) return;
      scanAccount(r);
      watch(r, function () { scanAccount(r); });
    });
  }

  [0, 300, 1000, 3000].forEach(function (d) { setTimeout(sweep, d); });
  document.addEventListener('shopify-render', sweep);
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('shopify-account')) setTimeout(sweep, 50);
  }, true);
})();
